import * as React from "react"
import { useState } from "react";
import { Dialog, DialogContent, DialogTitle, IconButton, Tooltip } from "@material-ui/core";
import VisibilityIcon from '@material-ui/icons/Visibility';
import { Close } from "@material-ui/icons";
import "./ProductGroupingNew.scss";

export interface IProductGroupingNewModalPros {
  item: any; 
}

const ProductGroupingNewModal:React.FC<IProductGroupingNewModalPros> = (props) => { 
  const { item } = props
  const [open, setOpen] = useState<boolean>(false) 

  const onClose = () => {
    setOpen(false)
  }

  const head = item.isbn + ' - ' + item.principal + ' - ' + item.titulo + ' - ' + item.editora

  return (
    <>
    <IconButton
    component={"span"}
    onClick={() => setOpen(true)}
    className="filter-dialog-close"
    color="primary"
  >
    <Tooltip title="Detalhes Relacionamento">
      <VisibilityIcon />
    </Tooltip>
  </IconButton>  
    <Dialog
    open={open}
    onClose={onClose}
    PaperProps={{ style: { width: "900px", maxWidth: "900px" } }}
    >
      <>
        <div className="title">
          <DialogTitle title={head}>{!!head ? head : head}</DialogTitle>
          <IconButton onClick={onClose}><Close /></IconButton>
        </div>
        <DialogContent> 
                {item.relacionados.map((v:any) => <div className="view-relation" key={v}>{v}</div>)}
        </DialogContent>
      </>
  </Dialog>
  </>
  );
}

export default ProductGroupingNewModal



// WEBPACK FOOTER //
// ./src/component/administration/registers/product-grouping-new/ProductGroupingNewModal.tsx